// extracted by mini-css-extract-plugin
module.exports = {"info":"assignToMeAlert_info__2OzMH","alertText":"assignToMeAlert_alertText__339fi"};